import {
  AppHeader,
  AppHeaderBackButton,
  Box,
  Button,
  Container,
  Stack,
  Typography,
  ButtonGroup,
  ScrollView,
  ScrollViewItem,
} from '@ace-clublabs/shared-component-library';
import memCardSample from '../assets/membership_card_sample.svg';
import aaaCreditCardImage from '../assets/aaa-credit-card-image.svg';
import addMemberImage from '../assets/add-member-image.svg';
import identityTheftImage from '../assets/identity-theft-image.svg';
import { useGlobalState } from '../state/state';
import MarketingCard from '../components/MarketingCard';
import { useHistory } from 'react-router-dom';
import { Pages } from '../utils/constants';
import { useLayoutEffect } from 'react';
import { UtagHelper, UtagType } from '../utils/UtagHelper';

export const Confirmation: React.FC = () => {
  const history = useHistory();
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [memberDetails] = useGlobalState('memberDetails');
  const { loggedInCustomerId, members, selectedCustomerId } = memberDetails;
  const numOfMembers = members?.length || 0;
  const selectedMemberInfo = members?.find((member) => member.customerId === selectedCustomerId);
  const loggedInMemberInfo = members?.find((member) => member.customerId === loggedInCustomerId);
  const capitalizeFirstLetter = (str: string = '') => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  const [tags] = useGlobalState('tags');

  useLayoutEffect(() => {
    UtagHelper.sendTag(UtagType.view, tags, 'confirmation', {});
    //setTagging(false);
  }, []);

  // if (isTagging) {
  //   return <></>;
  // }

  const selectedMemberName = `${capitalizeFirstLetter(selectedMemberInfo?.firstName)} ${capitalizeFirstLetter(
    selectedMemberInfo?.lastName
  )}`;
  const onAddMember = () => {
    UtagHelper.sendTag(UtagType.link, tags, 'confirmation', {
      cta: 'my account:account maintenance:replacement card:confirmation-add member',
    });
    window.location.href = '/membership/selfservice/select-associate-type';
  };
  const onCreditCard = () => {
    UtagHelper.sendTag(UtagType.link, tags, 'confirmation', {
      cta: 'my account:account maintenance:replacement card:confirmation-credit card',
    });
    window.open('https://www.ace.aaa.com/financial/aaa-credit-card.html', '_blank');
  };
  const onIdentityTheft = () => {
    UtagHelper.sendTag(UtagType.link, tags, 'confirmation', {
      cta: 'my account:account maintenance:replacement card:confirmation-id theft',
    });
    window.open('https://www.ace.aaa.com/financial/idtheft.html', '_blank');
  };

  const handleBackToMSSHomePage = () => {
    window.location.href = '/membership/selfservice';
  };

  return (
    <Container maxWidth="sm">
      <Box>
        <AppHeader
          backButton={
            !isMobileApp && (
              <AppHeaderBackButton
                label={
                  <Typography variant="b2Regular" fontWeight="500">
                    Back to my membership
                  </Typography>
                }
                onClick={handleBackToMSSHomePage}
                className="confirmation-back-button"
              />
            )
          }
          sx={{
            padding: '0 !important',
            '& .MuiButtonBase-root': {
              padding: '0 !important',
            },
          }}
        />
        <Stack>
          <Stack padding={'1.5rem 0 2.5rem 0'}>
            <img
              src={memCardSample}
              alt="membership-card-image"
              className="membership-card-image"
              style={{ width: '161px', alignSelf: 'center' }}
            />
          </Stack>

          <Typography variant="h5Medium" className="request-confirmation-title">
            Your replacement card request has been submitted
          </Typography>
          <Typography
            variant="b1Regular"
            className="request-confirmation-description"
            marginTop="0.5rem"
            lineHeight="1.5rem"
            data-qm-block="true"
          >
            A plastic replacement card for {selectedMemberName} will be processed and mailed in 15-20 business days.
          </Typography>
          <Typography
            variant="h6Medium"
            className="marketing-scroll-view-title"
            marginTop={'1.5rem'}
            marginBottom={'0.5rem'}
          >
            Members have also looked at...
          </Typography>
          <ScrollView
            sx={{
              '&>.MuiButtonBase-root.MuiIconButton-root': {
                display: 'none',
              },
              paddingLeft: '2px',
            }}
            spacing={'1rem'}
            className="confirmation-scroll-view"
          >
            <ScrollViewItem sx={{ width: '18.5rem' }}>
              <MarketingCard
                image={aaaCreditCardImage}
                title={`Hey ${capitalizeFirstLetter(loggedInMemberInfo?.firstName)},`}
                content="Earn cash back on everyday purchases everywhere using your AAA Visa Signature® credit card."
                buttonTitle="Learn more"
                buttonOnClick={onCreditCard}
                className="aaa-cc"
                data-qm-block="true"
              />
            </ScrollViewItem>
            <ScrollViewItem sx={{ width: '18.5rem' }}>
              <MarketingCard
                image={addMemberImage}
                title="Share peace of mind"
                content="Add family members as associates for a fraction of the price of your primary membership."
                buttonTitle="Add a member"
                buttonOnClick={onAddMember}
                className="add-member"
              />
            </ScrollViewItem>
            <ScrollViewItem sx={{ width: '18.5rem', paddingRight: '3px' }}>
              <MarketingCard
                image={identityTheftImage}
                title="AAA identity theft"
                content="Your identity belongs to you; make sure it stays that way with ProtectMyID®."
                buttonTitle="Enroll in ID theft protection"
                buttonOnClick={onIdentityTheft}
                className="id-theft"
              />
            </ScrollViewItem>
          </ScrollView>
          <ButtonGroup marginBottom={'3rem'}>
            <Button
              className="back-to-membership-button"
              label="Back to my membership"
              onClick={handleBackToMSSHomePage}
              fullWidth
              sx={{ marginTop: '1.25rem' }}
            />
            {numOfMembers > 1 && (
              <Button
                className="get-membership-card-button"
                label="Get membership card"
                onClick={() => {
                  history.push(Pages.SelectMemberPage);
                }}
                variant="outlined"
                fullWidth
              />
            )}
          </ButtonGroup>
        </Stack>
      </Box>
    </Container>
  );
};
